/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Layout_SaveInputs */

const vi_sidebar_layout_save = /** @type {(inputs: Sidebar_Layout_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu thứ tự`)
};

/**

* @param {Sidebar_Layout_SaveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sidebar_layout_save = /** @type {((inputs?: Sidebar_Layout_SaveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Layout_SaveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sidebar_layout_save(inputs)
});